module.exports = __webpack_public_path__ + "img/light_strip_power.b4cb0e22.png";